export const defaultState = {
  ui: {
    loading: false,
    errors: [],
  },
};

export const Reducer = (state = defaultState, action) => action.reduce(state);
